





























































































































































import {
  Component,
  Vue,
  Prop, Watch,
} from 'vue-property-decorator';
import {Getter} from 'vuex-class';
import SubscriptionsService from '@/services/subscriptions.service';
import { SubscriptionPlan, SubscriptionPlanRequest } from '../../types';
import moment from 'moment';

@Component({
  components: {},
})
export default class SubscriptionPlanAddDrawer extends Vue {
  @Getter private login: any;
  @Getter private organisations: any;
  @Prop({default: null}) private subscriptionPlan!: SubscriptionPlan | null;
  @Prop({default: true}) private showOrgSelect!: boolean;
  // @Prop({default: true}) private showSave!: boolean;
  @Prop({default: false}) private fromStock!: boolean;
  @Prop() private saveSubscriptionPlanExternal!: boolean;
  @Prop() private planTypes!: any;
  @Prop({default: -1}) private selectedOrg!: number;


  private defaultPlan: SubscriptionPlanRequest = {
    name: '',
    start_at: moment().format('YYYY-MM-DD'),
    activate_by: '',
    term_length: 365,
    total_subscriptions: 0,
    type: 'full',
    organisation_id: this.selectedOrg ? this.selectedOrg : -1,
    plan_type_code: 'SEED',
    // sigfox_subscription_pool_id?: number; TODO!
  };
  private plan: SubscriptionPlanRequest = this.defaultPlan;

  private orgList: any[] = [];
  private isSaving: boolean = false;

  private startAtMenu: boolean = false;
  private activateByMenu: boolean = false;

  @Watch('plan', {deep: true})
  private onPlanChange() {
    this.$emit('change:plan', this.plan);
    this.$emit('saving', this.isSaving);
  }

  @Watch('selectedOrg', {immediate: true})
  private onOrgSelect() {
    this.defaultPlan.organisation_id = this.selectedOrg;
  }

  private mounted() {
    if (this.subscriptionPlan) {
      this.plan = {
        id: this.subscriptionPlan.id,
        name: this.subscriptionPlan.name,
        start_at: this.subscriptionPlan.start_at ? moment(this.subscriptionPlan.start_at).format('YYYY-MM-DD') : '',
        activate_by: this.subscriptionPlan.activate_by ? moment(this.subscriptionPlan.activate_by).format('YYYY-MM-DD') : '',
        term_length: this.subscriptionPlan.term_length,
        total_subscriptions: this.subscriptionPlan.total_subscriptions,
        type: this.subscriptionPlan.type,
        organisation_id: this.subscriptionPlan.organisation.id,
        plan_type_code: this.subscriptionPlan.plan_type.code,
        // sigfox_subscription_pool_id?: number; TODO!
      };
    } else {
      this.plan = this.defaultPlan;
    }
    this.makeOrgList();
  }

  private makeOrgList() {
    this.orgList = this.organisations.organisations.map((org: any) => {
      return {
        text: org.name,
        value: org.id,
        billing_account: org.billing_account_id ? (org.billing_account.legal_entity_name ? org.billing_account.legal_entity_name : org.billing_account.name) : 'N/A',
      };
    });
  }

  @Watch('saveSubscriptionPlanExternal')
  private async saveExternal() {
    if (this.saveSubscriptionPlanExternal) {
      await this.save();
    }
  }

  private async save() {
    this.isSaving = true;
    try {
      // Sort the number columns
      this.plan.term_length = Number(this.plan.term_length);
      this.plan.total_subscriptions = Number(this.plan.total_subscriptions);
      const plan = this.plan.id
        ? await SubscriptionsService.updateSubscriptionPlan(this.plan)
        : await SubscriptionsService.createSubscriptionPlan(this.plan);

      this.fromStock ? this.$emit('savedSubscriptionPlan', plan) : this.$emit('savedSubscriptionPlan');
    } catch (e) {
      this.$emit('incompleteSubscriptionCreation');
    } finally {
      this.isSaving = false;
    }
  }

  private get startAt(): string {
    return this.plan.start_at ? moment(this.plan.start_at).format('DD MMM YYYY') : '';
  }

  private set startAt(val) {
    if (!val || !val.length) {
      this.plan.start_at = '';
    }
  }

  private get activateBy(): string {
    return this.plan.activate_by ? moment(this.plan.activate_by).format('DD MMM YYYY') : '';
  }

  private set activateBy(val) {
    if (!val || !val.length) {
      this.plan.activate_by = '';
    }
  }

  private get disableNumberOfSubs() {
    if (this.subscriptionPlan) { // editing
      return this.subscriptionPlan.plan_type.has_sims;
    } else if (this.fromStock) { // adding from sim stock
      return true;
    } else { // adding from subscription plans
      if (this.planTypes.length && this.plan.plan_type_code) {
        const type = this.planTypes.find((t: any) => t.text === this.plan.plan_type_code);
        return type.has_sims;
      } else {
        return true;
      }
    }
  }
}
